import { useVideoOnDemandQuery as useQuery } from '../schema'

export const useVideoOnDemandQuery: typeof useQuery = opts => useQuery(opts)
